import {Vue} from "ui.vue";
import CitrusVocabularyList from "./src/app.js"

Vue.component("CitrusVocabularyList", CitrusVocabularyList);

export {CitrusVocabularyList};